var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wpButton"},[(_vm.show)?_c('CustomButton',{class:_vm.buttonClass,attrs:{"link":_vm.conditionalLink}},[_vm._v("\n\t\t"+_vm._s(_vm.conditionalText)+"\n\t")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }